export class StaleUpdateError extends Error {}
